<p class="option" [ngClass]="font?.size" (click)="changeOption(option)" *ngFor="let option of options">
  {{ option?.name }}
</p>
